import {Component, OnInit} from '@angular/core';
import { AuthService } from './services/auth.service';
import { ScreenSizeService } from './services/screen-size.service';

export const configFilePath = 'assets/appConfig.json';
export const appVersionKey = 'currentAppVersion';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  mainWidth = '300px';
  mainHeight = '450px';
  iosAlert = false;

  constructor(
    private auth: AuthService,
    private sizeService: ScreenSizeService,
) { }

  ngOnInit(): void {
    const url = new URL(window.location.href);
    const loginRequired = url.pathname.startsWith('/dashboard');
    this.auth.autoLogin(loginRequired);

    // this.iosAlert = !!navigator.userAgent.match('CriOS');
    this.sizeService.initScreenSize();
    this.mainWidth = this.sizeService.appWidthPx;
    this.mainHeight = this.sizeService.appHeightPx;
  }
}


